import React from 'react'
import { Link, } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import CryoTheropy from "../assets/cryotherapy.jpg"
import { FaUserMd, FaLeaf, FaLaptopMedical, FaSpa, FaHeartbeat } from 'react-icons/fa';

const WhyChooseUs = () => {
    const { t } = useTranslation();
    const whyChooseUs = [
        {
          icon: <FaUserMd/>,
          title: t('whyChooseUs.reasons.expertCare.title'),
          description: t('whyChooseUs.reasons.expertCare.description')
        },
        {
          icon: <FaLeaf/>,
          title: t('whyChooseUs.reasons.personalizedApproach.title'),
          description: t('whyChooseUs.reasons.personalizedApproach.description')
        },
        {
          icon: <FaLaptopMedical/>,
          title: t('whyChooseUs.reasons.stateOfTheArtTech.title'),
          description: t('whyChooseUs.reasons.stateOfTheArtTech.description')
        },
        {
          icon: <FaSpa/>,
          title: t('whyChooseUs.reasons.warmAtmosphere.title'),
          description: t('whyChooseUs.reasons.warmAtmosphere.description')
        },
        {
          icon: <FaHeartbeat/>,
          title: t('whyChooseUs.reasons.commitmentWellness.title'),
          description: t('whyChooseUs.reasons.commitmentWellness.description')
        }
      ];
      
  return (
    <div className='container mx-auto flex md:flex-row flex-col-reverse gap-10 justify-around items-center my-20 p-6'>

      <div className='shadow-lg'>
        <img src={CryoTheropy} className='w-full rounded-md ' alt="Cryo Theropy"/>
      </div>


        <div className='md:w-2/5' data-aos='fade-up-right' >
            <h1 className="md:text-4xl leading-normal text-2xl font-semiobld font-Merriweather max-w-sm md:text-start text-center">{t('whyChooseUs.heading')}</h1>
            <p className="my-5 text-gray-600 md:text-sm text-xs font-semibold md:text-start text-center">{t('whyChooseUs.intro')}</p>
            {whyChooseUs.map((reason, key)=> (
                <div key={key} className='flex mt-5 justify-start items-start gap-5'>
                    <div className='text-3xl p-3 text-white bg-[rgb(161,121,61)] rounded-md'>
                        <span>{reason.icon}</span>
                    </div>
                    <div>
                        <h3 className='md:text-xl text-lg font-semibold font-Merriweather'>{reason.title}</h3>
                        <p className='text-xs text-gray-500 mt-2'>{reason.description}</p>
                    </div>
                </div>
            ))}
            <button   onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} className="p-2.5 px-5 bg-[rgb(161,121,61)] float-right text-white mt-5 rounded-md flex md:mx-0 mx-auto font-poppins font-medium">
              <Link to='/'>
              {t('whyChooseUs.buttonText')}
              </Link>
            </button>
      </div>
    </div>
  )
}

export default WhyChooseUs
